import React, {Component} from 'react';
import PhonesData from './PhonesData';
import { translate } from 'react-i18next';
import ModalPhoto from '../../toolbar/components/ModalPhoto';
import ModalFingerprint from '../../toolbar/components/ModalFingerprint';

var Config = require('../../../config');
class AvatarPerson extends Component{
	constructor(props, context) {
		super(props, context);

		this.state = { 
	    	don_usr_ndm:"",//criterio funcional cambiar lugar de colecta
	    	incidents:[],	
			folioAgenda:""   
	    }
	}
	
	componentDidMount() {
		this.props.onRef(this);
		//Criterio funcional, numero de donante manual
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_usr_ndm',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      don_usr_ndm: response
		    });
		})
	}

	componentWillUnmount() {
	    this.props.onRef(null)
	}

	openModalFingerprint(e){
		e.preventDefault();
		this.modal_fingerprint.handleShow(this.props.state.finger_image);
	}

	openModalPhoto(e){
		e.preventDefault();
		this.modal_photo.handleShow();
	}

	concatGroupRH(){
		var res = "";

		//console.log(this.props.stats)
		if(this.props.stats.lookup_rh==="POSITIVO"){
			res = this.props.stats.lookup_group+'+'
		}else if(this.props.stats.lookup_rh==="NEGATIVO"){
			res = this.props.stats.lookup_group+'-'
		}else{
			res = this.props.stats.lookup_group+'';
		}

		return res;
	}

	openModalIncidents(e){
		e.preventDefault();
		this.modal_incidents.handleShow();
	}


	render(){
		const { t } = this.props;
		return(
			<div style={{padding:"0px"}}>
				{this.props.stats.lookup_group!=="" && this.props.stats.lookup_group !== null?
					<div className="col-xs-12" style={{textAlign:'center'}}>
						<h2 style={{color:"#FF0000", fontWeight:'bold', margin:'0', fontSize:'80px', fontFamily: 'Roboto Condensed, sans-serif'}}>
							{this.concatGroupRH()}
						</h2>
					</div>
				:null}

			
				{(this.props.stats.lectina !== "" && this.props.stats.lectina !== null) &&
					<div className="col-xs-12" style={{textAlign:'center'}}>
						<h4>Subgrupo <span style={{color:'#ff0000', fontWeight:'bold'}}>{this.props.stats.lectina}</span></h4>
					</div>
				}

				<div className="col-xs-12">
					{this.props.state.hc_status === "" ?
						<div className="status-bar" 
		        			style={{
		        				backgroundColor:this.props.stats.status_bar_color,
		        				marginBottom:"5px", 
		        				textAlign:"center"
		        			}} >
			            	<label style={{color:"white",margin:"3px"}}>
			            		{this.props.stats.temporality === 'ACEPTADO' ? '' : this.props.stats.temporality}
			            	</label>
			            </div>

					: <div className="status-bar" 
		        			style={{
		        				backgroundColor:this.props.stats.status_bar_color,
		        				marginBottom:"5px", 
		        				textAlign:"center"
		        			}} >
			            	<label style={{color:"white",margin:"3px"}}>
			            		{this.props.stats.temporality}
			            	</label>
			            </div>
			        }
					{/*this.props.stats.total_hc !== 0?*/}
		        		
		            {/*:null*/}
				</div>

				<div className="col-xs-12" style={{textAlign:"center",align:"center"}}>
	        		{this.props.state.photo.length===0?
        				<img style={{height:'180px',width:'168px',textAlign:"center"}} src="../../default_user.jpg" alt="USER"/>
        				
        				:<img style={{height:'180px',width:'168px',textAlign:"center"}} src={this.props.state.photo} alt="default"/>
        				
	        		}
		        </div>

		        <div className="col-xs-12">
		        	<div className="col-xs-10 col-sm-offset-1">
						<div style={{textAlign:"center"}} className="col-xs-12 col-sm-6">
			        		{this.props.don_hue_dig.value==="YES"?
			        			<button onClick={(e) => this.openModalFingerprint(e)} 
			        				className={this.props.state.finger_image!==""?
			        					"btn btn-info btn-sm":"btn btn-info btn-sm"}
			        			 style={{fontSize:".7em",width:"70px",margin:"5px", width:'100%'}} type="button">HUELLA</button>
		        			:null}
		        		</div>

						<div className="col-xs-12 col-sm-6">
		        			<button onClick={(e) => this.openModalPhoto(e)} className="btn btn-info btn-sm btn-second" 
		        				style={{fontSize:".7em",width:"70px",margin:"5px", width:'100%'}} type="button">FOTO</button>
			        	</div>
		        	</div>
		        </div>

		        
				{this.props.agenda?
					<div className="col-xs-10 col-xs-offset-1">
						<hr className="avatar-hr"/>
						<span className="col-xs-6">No. de folio</span>
						<div className="col-xs-6">
							<input name="folio" id="folio" value={ this.state.folio } 
								onChange={ this.props.handleChange } type="number" min="1"
								className="form-control" disabled/>
						</div>
					</div>
					:<div>
						<div className="col-xs-10 col-xs-offset-1">
							<hr className="avatar-hr"/>
							<span className="col-xs-6">No. de Ofrecimiento</span>
							<div className="col-xs-6">
								<input name="offer_id" id="offer_id" value={ this.props.offer_id } 
									onChange={ this.props.handleChange } type="number" min="1"
									className="form-control" disabled/>
							</div>
						</div>
						<div className="col-xs-10 col-xs-offset-1">
							<hr className="avatar-hr"/>
							<span className="col-xs-6">No. de Donador</span>
							<div className="col-xs-6">
								<input name="donor_number" id="donor_number" value={ this.props.donor_number } 
									onChange={ this.props.handleChange } type="number" min="1"
									className="form-control" disabled={this.state.don_usr_ndm.value === "NO"}/>
							</div>
						</div>
					</div>
				}
				

				<div className="col-xs-11" style={{marginLeft:'7%'}}>
					
					{this.props.stats.total_donations !== 0?
		        	<div>
		        		<hr className="avatar-hr"/>
		        		<div className="col-xs-12">
				        	<span className="title-avatar">
				        		{this.props.stats.date_label}
				        	</span>
			        	</div>
			        	<div className="col-xs-12 col-sm-3" style={{padding:"0px"}}>
				        	<span style={{fontSize:'.7em'}}>
				        		{this.props.stats.last_donation_date}
				        	</span>
			        	</div>
			        	<div style={{padding:'0px'}}>
			        		<div className="col-xs-12 col-sm-5">
					        	<span style={{fontSize:'.7em'}}>
					        		{this.props.stats.donation_type}
					        	</span>
				        	</div>
					        <div className="col-xs-12 col-sm-4" style={{padding:"0px"}}>
					        	<span style={{fontSize:'.7em'}}>
					        		{this.props.stats.extraction_type}
					        	</span>
					        </div>
				        </div>
		        	</div>
		        	:null}
				</div>

				<div className="form-group col-xs-11" style={{marginLeft:'7%'}}>
					
					{this.props.stats.total_donations !== 0 ?

	        			<div>
	        				<hr className="avatar-hr"/>

	        				<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
	        					Total ofrecimientos
			        			<span className="donations-avatar">
			        				{this.props.stats.total_offers}
			        			</span>
			        		</div>

	        				<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
	        					{t('content.offers.form.total_donations')}:
			        			<span className="donations-avatar">
			        				{this.props.stats.total_donations}
			        			</span>
			        		</div>
			        		
			        		<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
			        			{t('content.offers.form.last_12_months')}:
			        			<span className="donations-avatar">
			        				 {this.props.stats.total_last_year}
			        			</span>
			        		</div>
			        	</div>
		        	:null}
				</div>

		        <PhonesData disableElement={this.props.state.disableOnView} phonesAdded={this.props.phonesAdded} state={this.state} handleChange={this.props.handleChange} selectFieldHandle={this.props.selectFieldHandle} addPhoneToList={this.props.addPhoneToList} removePhoneFromList={this.props.removePhoneFromList}/>
		        <ModalFingerprint {...this.props} onRef={ref => (this.modal_fingerprint = ref)} save={this.props.updateFingerprint}/>
				<ModalPhoto {...this.props} onRef={ref => (this.modal_photo = ref)} save={this.props.returnPhoto}/>
		    </div>
		)
	}
}

export default translate('translations')(AvatarPerson);